<template>
  <div class="bg-white p-3 rounded">
    <span>
      <i class="fa fa-info-circle mr-2 orange" />
      <span class="title">Historial de Estatus</span>
    </span>
    <CustomTimeLine :items="items" />
  </div>
</template>

<script>
import CustomTimeLine from 'custom-time-line';

export default {
  name: 'StatusTimeline',
  components: {
    CustomTimeLine,
  },
  data: () => ({ items: [] }),
  props: {
    history: { type: Array, default: () => [] },
  },
  mounted() {
    this.items = this.history.map((x) => ({
      status: {
        text: x.status.text,
        color: x.status.color,
      },
      date: this.$options.filters.date(x.date),
      text: x.requester.name + '\r\n' + x.requester.position,
    }));
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_colors.scss';

.orange {
  color: map-get($colors, 'orange');
}
.title {
  font: normal normal bold 16px/19px Lato;
  letter-spacing: 0px;
  color: map-get($colors, 'gray-7');
}
</style>
